import React, { FC } from 'react';
import styles from './Header.scss';
import WixLogo from 'assets/svgs/wix-logo.svg';
import PrintfulLogo from 'assets/svgs/printful-logo.svg';
import { DismissSmall } from '@wix/wix-ui-icons-common';

export const HeaderLogo: FC = () => {
  return (
    <div className={styles.headerLogo}>
      <WixLogo />
      <DismissSmall className={styles.headerLogoDismissIcon} />
      <PrintfulLogo />
    </div>
  );
};
